var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgC6 = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("g", {
    clipPath: "url(#clip0_2667_3217)"
  }, React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1F1F1F"
  }), React.createElement("path", {
    d: "M12.4274 17.9268C12.8117 17.5904 13.0622 17.1482 13.1803 16.6008H16.9745C16.8006 18.1655 16.1707 19.4322 15.0853 20.402C13.9994 21.3718 12.6625 21.8569 11.0757 21.8569C9.91815 21.8569 8.87622 21.6025 7.94941 21.0941C7.02259 20.5857 6.29932 19.8793 5.77959 18.9747C5.25986 18.0701 5 17.0549 5 15.9285C5 14.802 5.25986 13.7868 5.77959 12.8822C6.29932 11.9776 7.02259 11.2712 7.94941 10.7628C8.87622 10.2539 9.91815 10 11.0757 10C12.6373 10 13.9559 10.4679 15.0314 11.4041C16.1065 12.3398 16.7418 13.5665 16.936 15.0836H13.1961C13.0375 14.5832 12.7663 14.1805 12.3819 13.8752C11.998 13.5704 11.5677 13.4178 11.0915 13.4178C10.4359 13.4178 9.90728 13.6485 9.50563 14.1099C9.10298 14.5713 8.90241 15.1775 8.90241 15.928C8.90241 16.674 9.10496 17.2777 9.50908 17.7391C9.91419 18.2005 10.4408 18.4308 11.0915 18.4308C11.5984 18.4308 12.0435 18.2628 12.4274 17.9268ZM25.8948 14.844C26.6314 15.5505 27 16.4645 27 17.5845C27 18.865 26.5761 19.8976 25.7279 20.6811C24.8791 21.4651 23.7616 21.8569 22.3733 21.8569C21.0019 21.8569 19.8868 21.4637 19.0277 20.6771C18.1681 19.8901 17.7388 18.8709 17.7388 17.6176C17.7388 16.9333 17.8568 16.2446 18.0925 15.552C18.3282 14.8594 18.6928 14.1015 19.1863 13.2794L20.9303 10.3794L24.6158 10.3789L22.5522 13.8006C22.7582 13.7898 22.9207 13.7843 23.0403 13.7843C24.2057 13.7843 25.1572 14.1376 25.8948 14.844ZM23.4064 18.6358C23.6717 18.3655 23.8046 18.0153 23.8046 17.5845C23.8046 17.1542 23.6717 16.8009 23.4064 16.5248C23.1406 16.2486 22.7962 16.1108 22.3738 16.1108C21.9509 16.1108 21.6061 16.2491 21.3413 16.5248C21.075 16.8009 20.9426 17.1542 20.9426 17.5845C20.9426 18.0153 21.075 18.3655 21.3408 18.6358C21.6061 18.9065 21.9509 19.0419 22.3733 19.0419C22.7962 19.0419 23.1411 18.9065 23.4064 18.6358Z",
    fill: "white"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_2667_3217"
  }, React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  }))));
};
export default SvgC6;